import { Link } from "react-router-dom";
import PageBanner from "../../component/PageBanner";
import SectionHeader from "../SectionHeader";
import React from "react";
import {
  FaBarcode,
  FaMicrochip,
  FaChartLine,
  FaTv,
  FaRecycle,
} from "react-icons/fa";
import SocialMediaSidebar from "../SocialMediaSidebar";
import ScrollToTopButton from "../ScrollToTopButton";
import SectionHeaderNoPDF from "../SectionHeaderNoPDF";

const StoryofWaste = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="The Story of Waste"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "About Us" },
          { label: "Story" },
        ]}
      />

      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Story of Waste @ AJEEVI"
          shareUrl="https://swachhajv.ajeevi.in/story-of-waste"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>
      
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 text-[#1a1a1a] font-sans bg-white text-justify">
        {/* Header Section */}
        <h2 className="text-[#00D084] font-semibold text-2xl mb-2">
          The Story of Waste
        </h2>
        <h1 className="text-3xl md:text-2xl font-bold mb-6">
          Revolutionizing Waste Management Through IoT and Automation
        </h1>

        <p className="text-black text-lg mb-8">
          In recent years, expanding urbanisation and industrial growth have
          resulted in a large increase in waste creation, creating a significant
          challenge to effective waste management. Traditional waste management
          methods frequently fail in terms of efficiency and sustainability,
          resulting in environmental damage and increasing operational expenses.
          To meet these issues, the integration of new technology has become
          critical. One such invention is the IoT-based Smart Waste Management
          System, which uses the Internet of Things (IoT) to improve waste
          collection, segregation, and disposal. In order to effectively monitor
          and manage garbage, the IoT-based Smart garbage Management System uses
          a network of sensors, data analytics, and automated technologies.
          These smart devices provide real-time data on waste levels in bins,
          allowing for prompt and efficient waste collection. Waste management
          authorities can use IoT technology to dynamically route collection
          vehicles based on real-time data, decreasing fuel usage and
          environmental effect. Moreover, the smart waste management system can
          help with recycling efforts by properly separating different types of
          waste at the source. This not only improves the efficiency of
          recycling processes, but also lowers contamination in recyclable
          materials. Furthermore, data acquired via IoT devices may be analysed
          to gain insights into waste generation trends, allowing for the
          development of improved waste management policies and plans.
        </p>

        {/* RFID Section */}
        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          {/* Card */}
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaBarcode />
            </div>
            <h3 className="text-xl font-bold mb-2">RFID & QR Code Tagging</h3>
            <p className="text-black text-lg">
              Each bin is tagged and logged, creating a connected asset network
              for real-time tracking and record management.
            </p>
          </div>

          {/* Text */}
          <div className="text-black text-lg leading-relaxed">
            <p>
              Our journey starts at the source. Every waste bin is tagged using{" "}
              <span className="font-bold">RFID</span> or
              <span className="font-bold"> QR code</span> technology, giving it
              a unique digital identity. These tags store bin-specific data such
              as location, type, and collection schedules—allowing it to be
              tracked, managed, and maintained efficiently.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          {/* Text */}
          <div className="text-black text-lg leading-relaxed">
            <p>
              Once bins are tagged, the real magic begins. IoT sensors installed
              inside bins continuously monitor fill levels and transmit this
              data over a secure network. This removes the guesswork from waste
              collection.
            </p>
          </div>

          {/* Card */}
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaMicrochip />
            </div>
            <h3 className="text-xl font-bold mb-2">Smart Sensors</h3>
            <p className="text-black text-lg">
              Detect fill levels, temperature, and movement—keeping the system
              updated in real-time.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          {/* Card */}
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaChartLine />
            </div>
            <h3 className="text-xl font-bold mb-2">Data Driven Insights</h3>
            <p className="text-black text-lg">
              Real-time bin data, collection trends, and performance metrics
              drive intelligent decision-making for route optimization.
            </p>
          </div>

          {/* Text */}
          <div className="text-black text-lg leading-relaxed">
            <p>
              With continuous data collection from IoT bins and vehicle
              trackers, the system identifies fill patterns and peak times.
              These insights power dynamic and optimized route
              planning—minimizing fuel usage, reducing operational costs, and
              improving overall efficiency.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          {/* Text */}
          <div className="text-black text-lg leading-relaxed">
            <p>
              Real-time alerts notify collection teams of urgent pickups, while
              authorities monitor the entire system through a central dashboard.
              Maintenance schedules, reports, and performance analytics are
              generated automatically.
            </p>
          </div>
          {/* Card */}
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaTv />
            </div>
            <h3 className="text-xl font-bold mb-2">Centralized Monitoring</h3>
            <p className="text-black text-lg">
              Real-time dashboards, alerts, and analytics help authorities stay
              informed and proactive.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          {/* Card */}
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaRecycle />
            </div>
            <h3 className="text-xl font-bold mb-2">
              Smart Recycling & Sorting
            </h3>
            <p className="text-black text-lg">
              Integration with sorting centers ensures high recovery rates and
              low contamination.
            </p>
          </div>
          {/* Text */}
          <div className="text-black text-lg leading-relaxed">
            <p>
              In the final step, waste data is linked with smart sorting
              facilities, helping improve segregation and recycling. Every
              decision—from bin placement to fleet size—is now guided by data,
              not guesswork.
            </p>
          </div>
        </div>

        <div className="py-10 px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-2">
            This is not just waste collection. This is smart, sustainable,
            data-driven urban innovation.
          </h2>
          <p className="text-gray-500 text-sm md:text-base">
            A cleaner tomorrow begins with smarter systems today.
          </p>
        </div>
      </div>
    </>
  );
};

export default StoryofWaste;
